<div *ngIf="commonService.supplierRole"
  class="unauthorized-message">
  {{commonService.Notautorized}}
</div>
<div *ngIf="!commonService.supplierRole">
<div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
  <section id="Noprop"
           class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 mb-0-important">
    <div class="d-flex align-items-center m-0 pb-1">
      <div class="col-4 pl-0"></div>
      <div class="center col-4 text-center">
        <img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png"
             class="logo-max-width" alt="edit">
      </div>

      <div class="col-4 text-right">
        <div> <app-helpsection></app-helpsection></div>

      </div>
        </div>
  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <app-suppliertab></app-suppliertab>
    <div class="row m-0 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">SEARCH</h4>
      </div>
      <div class="col col-3 col-sm-1 col-md-1 col-lg-1 col-xl-1">
    <button *ngIf="superUserShow" type="button" class="btn btn-custom btn-custom-lg btn-purple mb-2 k2Website" (click)="openK2Website()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (openK2Website())"> K2 Website </button>
    <button *ngIf="superUserShow" type="button" class="btn btn-custom btn-purple k2Token" (click)="copyAccessToken()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (copyAccessToken())"> K2 Token </button>
  </div>
  </div>
    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
        <label class="label-control" for="supplierInput">Supplier
        </label>
        <p class="pr-4 m-0">
          <input type="text"
                 id="supplierInput"
                 class="form-control form-control-sm supplier-input"
                 [(ngModel)]="companyNameModel"
                 (ngModelChange)="companyNameModel = $event.toUpperCase()">
        </p>
        <small class="float-right pr-4 btn-close search-close-btn" title="Clear">
          <button type="button" (click)="clearFields('company')"
          class ="cancel cancel-button"
             (keydown.enter)="clearFields('company')"
             (keydown.space)="clearFields('company')"
             tabindex="0">X</button>
        </small>
      </div>
    </div>

    <div class="row m-0 ml-3 align-center">
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
        <span class="px-2 font-weight-bold">OR</span>
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
    </div>

    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 pb-0 mb-0">
        <mat-label class="label-control">Identifier Type</mat-label>
          <mat-select class="form-control form-control-sm dropdown-select"
                      [(ngModel)]="identifierTypeModel"
                      panelClass="dropdown-panel"
                      [disableOptionCentering]="true">
            <mat-option value="workflowId">Request ID</mat-option>
          </mat-select>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mt-3">
        <label class="label-control" for="identifierValueInput">Identifier Value
        </label>
        <p class="pr-4 m-0">
          <input type="text"
                 id="identifierValueInput"
                 class="form-control form-control-sm"
                 [(ngModel)]="workflowIdModel">
        </p>
        <small class="float-right pr-4 search-close-btn" title="Clear">
          <button type="button" (click)="clearFields('workflowId')"
          class ="cancel cancel-button"
             (keydown.enter)="clearFields('workflowId')"
             (keydown.space)="clearFields('workflowId')"
             tabindex="0">X</button>
        </small>
      </div>
    </div>

    <div class="row m-0 align-center">
      <div class="form-group col col-6 col-sm-9 col-md-6 col-lg-6 col-xl-6">
      </div>

      <div class="form-group col col-6 col-sm-12 col-md-6 col-lg-6 col-xl-6 text-right" >
          <button type="button" class="btn btn-custom btn-link" (click)="clearFields('All')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearFields('All'))"> Clear All </button>
          <button type="button" class="btn btn-custom btn-custom-lg btn-blue" (click)="getSearch()"> Search </button>
      </div>
    </div>

  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <div class="row m-0 pt-3 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">RESULTS
          <span *ngIf="loadData==true && workFlowDetails && workFlowDetails.length>=0">
            ({{PageTotalLength}})
          </span>
        </h4>
      </div>

      <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2">
        <button type="button"
                class="btn btn-custom btn-darkred float-right export-btn-width"
                (click)="ExportTOExcel()"
                *ngIf="roleVariableHide" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (ExportTOExcel())">
          <mat-icon svgIcon="download" aria-hidden="true" class="thick-icon export-icon"></mat-icon>
          <span class="float-right"> Export </span>
        </button>
      </div>
    </div>

    <div class="row m-0">
      <div class="table-responsive mt-3 overflow-visible">
         <div [ngClass]="{ 'fixTableHead' :loadData == true, 'fixTableFoot' :loadData == true }">
           <table class="table table-sm m-0">
            <thead>
             <tr>
              <th class="sortDecorationunderline th-left-w-0"
                  (click)="sort('Request Id')"
                  (keydown.enter)="sort('Request Id')"
                  (keydown.space)="sort('Request Id')"
                  tabindex="0">Request Id</th>
              <th class="sortDecorationunderline th-left-w-6"
                  (click)="sort('supplierName')"
                  (keydown.enter)="sort('supplierName')"
                  (keydown.space)="sort('supplierName')"
                  tabindex="0">Supplier</th>
              <th class="th-left-w-4">Requestor</th>
              <th class="th-left-w-6-no-decoration">Approver</th>
              <th class="th-left-w-4">Request Type</th>
              <th class="th-left-w-7">Notes</th>
              <th class="th-left-w-2">Date</th>
              <th class="th-status">Status
                <span>
                  <div class="dropdown d-inline">
                    <button class="edit cancel" type="button" id="dropdownMenuButton"
                            (click)="showDropdownStatus()"
                            (keydown.enter)="showDropdownStatus()"
                            (keydown.space)="showDropdownStatus()"
                            tabindex="0">
                      <mat-icon *ngIf="statusFiltered" svgIcon="filter-1" class="img-btn img-btn-sm"></mat-icon>
                      <mat-icon *ngIf="!statusFiltered" svgIcon="filter-2" class="img-btn img-btn-sm"></mat-icon>
                    </button>
                  </div>
                </span>
                <div *ngIf="showFilterStatus" data-toggle="modal" class="filter-dropdown">
                  <ng-container class="bg-white">
                    <ul class="m-0 p-0 pt-1 list-unstyled filter-list-size">
                      <li class="filter-item"
                          *ngFor="let status of statusOrder">
                        <span>
                          <input type="checkbox"
                                 [id]="status.replace('In progress','Inprogress').replace('Need more info','Needmoreinfo')"
                                 (click)="setCheckboxVal(status.replace('In progress','Inprogress')
                                   .replace('Need more info','Needmoreinfo'))"
                                 (keydown.space)="setCheckboxVal(status.replace('In progress','Inprogress')
                                   .replace('Need more info','Needmoreinfo'))"
                                 (keydown.enter)="setCheckboxVal(status.replace('In progress','Inprogress')
                                   .replace('Need more info','Needmoreinfo'))"
                                 value="{{status}}"
                                 class="edit checkboxAt">&nbsp;&nbsp;
                          <label [for]="status.replace('In progress','Inprogress').replace('Need more info','Needmoreinfo')"
                                 class="group-status-1"
                                 [ngStyle]="{'background':getColor2(status)}">
                            {{status}}
                          </label>
                        </span>
                      </li>
                    </ul>
                    <div class="modal-footer py-0 pr-0 border-0 mt-2">
                      <button type="button" class="btn btn-custom btn-link bg-none" (click)="showDropdownStatus('close')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (showDropdownStatus('close'))">Clear</button>
                      <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="filterStatus()">OK</button>
                    </div>
                  </ng-container>
                </div>
              </th>
            </tr>
          </thead>

          <tbody *ngIf="loadData==true && workFlowDetails && workFlowDetails.length>=0">
            <tr *ngFor="let detail of workFlowDetails | orderBy: key:reverse;let i=index" >
              <ng-container *ngIf="detail.filterTrue == true">
                <td>
                  <span>
                    <a href="javascript:void(0);"
                            (click)="notesHistoryOpen(detail)"
                            class="font-weight-bold label-darkblue"
                            data-toggle="modal"
                            data-target="#notesHistory" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (notesHistoryOpen(detail))">{{detail['requestId']}}</a>&nbsp;
                        <button class="btn btn-custom btn-purple k2-btn"
                          *ngIf="superUserShow==true"
                            (click)="openWorkflow(detail['requestId'])">
                    K2
                  </button></span>
                </td>
                <td><a class="label-darkblue" [routerLink]="['/company-details',detail.companyId]">{{detail['supplierName']}}</a></td>
                <td>
                  <span>
                    <a href="mailto:{{detail['RequestorMailId']}}?subject=ISA - {{detail['requestId']}} / {{detail['supplierName']}}"
                       class="underline-link">{{detail['requestor']['displayName']}}</a>
                  </span>
                </td>
                <td>
                  <span *ngIf="detail['workflowOwnerWithRole']">
                    <span *ngFor="let owners of detail['workflowOwnerWithRole']" class="display-block">
                      <span *ngIf="owners.length!=7">{{owners}} ({{detail['currentValidtor']}})</span>
                      <span *ngIf="owners.length==7" class="error-color">{{owners}}</span>
                    </span>
                  </span>
                  <span *ngIf="!detail['workflowOwnerWithRole']">-</span>
                </td>
                <td>{{detail['strRequestType']}}</td>
                <td>
                  <span *ngIf="detail['historys'].length==0">{{detail['lastComment'] ? detail['lastComment'] : '-'}}</span>
                  <span *ngIf="detail['historys'].length>0">
                  </span>
                  <span *ngIf="detail['historys'].length==1">
                    {{detail['historys'][detail['historys'].length-1] ?
                      detail['historys'][detail['historys'].length-1]['comment'] : '-'}}
                  </span>

                  <span *ngIf="detail['historys'].length>1">
                    {{detail['historys'][detail['historys'].length-1] ['route'].trim() !="Submitted" ?
                      detail['historys'][detail['historys'].length-1]['comment'] :
                      detail['historys'][detail['historys'].length-2]['comment'] }}
                  </span>
                </td>
                <td>{{detail['creationDate'] ? (detail['creationDate'] | date:'yyyy-MM-dd') : '-'}}</td>
                <td>
                  <div class="d-flex flex-column w-100">
                    <div class="d-flex align-items-center flex-wrap mb-1">
                      <div class="group-status flex-shrink-0 me-2 status-badge"
                           [ngStyle]="{'background':colorForWorkflow[detail['status']],'min-width': '82px','height':'22px'}">
                        {{detail['status']}}
                      </div>

                      <div class="d-flex align-items-center"
                           *ngIf="detail['workflowOwner'] && detail['workflowOwner'].indexOf(Uid)!=-1">
                        <mat-icon svgIcon="confirm" alt="greentick"
                                  class="rounded-circle svg-icon green me-1 action-icon"
                                  (click)="loadWorkflowValidation('valid',detail['folio'],detail['requestId'],
                                    detail['allianceId'],detail['strRequestType'],detail['currentValidtor'])"
                                  (keydown.enter)="loadWorkflowValidation('valid',detail['folio'],detail['requestId'],
                                    detail['allianceId'],detail['strRequestType'],detail['currentValidtor'])"
                                  (keydown.space)="loadWorkflowValidation('valid',detail['folio'],detail['requestId'],
                                    detail['allianceId'],detail['strRequestType'],detail['currentValidtor'])"
                                  tabindex="0"
                                  data-toggle="modal"
                                  data-target="#showWorkflowValidation"></mat-icon>
                        <mat-icon svgIcon="less" alt="redClose"
                                  class="rounded-circle red me-1 action-icon"
                                  (click)="loadWorkflowValidation('reject',detail['folio'],detail['requestId'])"
                                  (keydown.enter)="loadWorkflowValidation('reject',detail['folio'],detail['requestId'])"
                                  (keydown.space)="loadWorkflowValidation('reject',detail['folio'],detail['requestId'])"
                                  tabindex="0"
                                  data-toggle="modal"
                                  data-target="#showWorkflowRejection"></mat-icon>
                        <mat-icon *ngIf="commonService.infobtndsp(detail['folio'])"
                                  svgIcon="information"
                                  class="info-color me-1 action-icon"
                                  (click)="loadWorkflowValidation('info',detail['folio'],detail['requestId'])"
                                  (keydown.enter)="loadWorkflowValidation('info',detail['folio'],detail['requestId'])"
                                  (keydown.space)="loadWorkflowValidation('info',detail['folio'],detail['requestId'])"
                                  tabindex="0"
                                  data-toggle="modal"
                                  data-target="#showWorkflowInfoRequest"></mat-icon>
                      </div>
                    </div>

                    <div class="d-flex align-items-center flex-wrap" *ngIf="detail['workflowOwner']">
                      <mat-icon svgIcon="mail" class="icon me-1 mail-icon"
                                *ngIf="detail['workflowOwnerWithRole'] && roleVariableHide==true && superUserShow==true
                                  && (detail['status']=='In progress'|| detail['status']=='Need more info')
                                  && detail['date']==true && detail['supportipn']==false"
                                data-toggle="modal"
                                data-target="#createMailModalPopup"
                                (click)="updatemailModelName(detail['historys'],detail['folio'],
                                  detail['requestId'],detail['difference'],detail)"
                                (keydown.enter)="updatemailModelName(detail['historys'],detail['folio'],
                                  detail['requestId'],detail['difference'],detail)"
                                (keydown.space)="updatemailModelName(detail['historys'],detail['folio'],
                                  detail['requestId'],detail['difference'],detail)"
                                tabindex="0"></mat-icon>
                      <span class="text-primary fs-14" *ngIf="detail['difference']">({{detail['difference']}}&nbsp;d)</span>
                    </div>
                  </div>
                </td>
            </ng-container>
            </tr>
          </tbody>

          <tbody *ngIf="loadData == false" >
            <tr>
              <td colspan="8" class="font-weight-bold label-darkblue text-center"> No Results</td>
            </tr>
          </tbody>

          <tfoot *ngIf="workFlowDetails && workFlowDetails.length>0 && PageTotalLength>50" >
            <tr>
              <td colspan="8">
                <ul *ngIf="pager.pages && pager.pages.length && paginationForStatus==false" class="pagination">
                  <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="getSearch(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getSearch(1))">First</a>
                  </li>
                  <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="getSearch(pager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getSearch(pager.currentPage - 1))">Previous</a>
                  </li>
                  <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                      <a (click)="getSearch(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getSearch(page))">{{page}}</a>
                  </li>
                  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="getSearch(pager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getSearch(pager.currentPage + 1))">Next</a>
                  </li>
                  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="getSearch(pager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (getSearch(pager.totalPages))">Last</a>
                  </li>
                </ul>
                <ul *ngIf="pager.pages && pager.pages.length && paginationForStatus==true" class="pagination">
                  <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="setPage(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(1))">First</a>
                  </li>
                  <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="setPage(pager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(pager.currentPage - 1))">Previous</a>
                  </li>
                  <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                      <a (click)="setPage(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(page))">{{page}}</a>
                  </li>
                  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="setPage(pager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(pager.currentPage + 1))">Next</a>
                  </li>
                  <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="setPage(pager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setPage(pager.totalPages))">Last</a>
                  </li>
                </ul>
              </td>
            </tr>
          </tfoot>
           <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
        </table>
      </div>
      </div>
    </div>
  </section>
</div>

<div class="modal fade"  id="createMailModalPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel1">
            Reminder
          <button type="button" class="close" id="closeCCBtnReminder" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="mb-3">
              <p class="mb-1"><strong>{{ currentModalDetail?.allianceId }} {{ currentModalDetail?.supplierName }}</strong></p>
              <p class="mb-1"><strong>Approver : </strong>
                <span *ngIf="currentModalDetail?.workflowOwnerWithRole">
                  <span *ngFor="let owners of currentModalDetail.workflowOwnerWithRole">
                  <span *ngIf="owners && owners.length!=7">{{owners}} ({{currentModalDetail.currentValidtor}})</span>
                  <span *ngIf="owners && owners.length==7" class="error-color">{{owners}}</span>
                </span></span>
                <span *ngIf="!currentModalDetail?.workflowOwnerWithRole">-</span>
              </p>
              <p class="mb-1"><strong>Send to : </strong> {{ approverEmail }}</p>
            </div>
            <label class="label-control" for="reminderNotesTextarea">
              <h4 class="title px-2" >Reminder Notes</h4>
            </label>
            <div class="textAreaClear">
            <textarea id="reminderNotesTextarea"
            rows="3" cols="60"
              [(ngModel)]="MailNameModel">
            </textarea>
            <span class="ng-clear-wrapper" title="Clear all">
              <button class="ng-clear textClear cancel"
                      (click)="resetCompanyNameFields()"
                      (keydown.enter)="resetCompanyNameFields()"
                      (keydown.space)="resetCompanyNameFields()"
                      tabindex="0">×</button>
            </span>
          </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button class="btn btn-custom btn-blue float-right mb-4" (click)="sendblueRequestForMailToApp()">
            <img src="assets/images/mail-wt-md.png" class="img-btn img-btn-lg" alt="">
            Send to Approver
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="showWorkflowValidation" tabindex="-1" aria-modal="true"
     aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-ml-9">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel2">
          Workflow Validation
          <button type="button" class="close" id="closeWorkflowValidation" #closeBtn
                  data-dismiss="modal" aria-label="Close" [hidden]="validatingWorkflow">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow && checkboxSelect">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="confirmationOption" id="confirmationCheckbox">
              <label class="form-check-label fontBold" for="confirmationCheckbox">
                I confirm that the supplier has been approved through an RPC within the past 3 years
                or an NSQV within the past 6 months, and has received a favorable TIM assessment,
                along with financial and GREF quotations.
              </label>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow && checkboxSelect">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="documentsReviewOption" id="documentsReviewCheckbox">
              <label class="form-check-label fontBold" for="documentsReviewCheckbox">
                Documents to be reviewed by the validator:<br>
                -TIM result<br>
                -Financial quotation<br>
                -GREF quotation<br>
                -Strategy: RPC document or SDC for New Supplier Quick Validation (NSQV) process
              </label>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow">
            <label class="label-control fontBold" for="workflowValidationNotes"> NOTES :</label>
            <textarea id="workflowValidationNotes" class="form-control form-control-sm"
                      [(ngModel)]="wkfValNotesModel" maxlength="1000"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button class="ng-clear cancel"
                      (click)="resetWkfValNotesModel()"
                      (keydown.enter)="resetWkfValNotesModel()"
                      (keydown.space)="resetWkfValNotesModel()"
                      tabindex="0">×</button>
            </span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div *ngIf="validatingWorkflow" class="label-control fontBold"> Please wait ..</div>
           </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" [disabled]="validatingWorkflow"> Cancel </button>
          <button type="button"
                  class="btn btn-custom btn-custom-sm btn-blue"
                  (click)="validateWkfNoteRoute()"
                  [disabled]="workflowValidationLoading==true || !isValidationFormComplete()">
            <div class="icon-text-container">
              <mat-icon svgIcon="confirm" alt="greentick"  class="rounded-circle svg-icon icon-pr-2"  > </mat-icon>
<span>Validate</span>
            </div>

          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal-above" id="ArcaPopup" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-custom">
  <div class="modal-content">
    <div class="modal-header border-0">
      <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel3">
        Search User
        <button type="button" class="close" id="closeGCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </h6>
    </div>
    <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-section">
      <label class="label-control" for="ipnInput">IPN
      </label>
      <input type="text"
             id="ipnInput"
             class="form-control form-control-sm"
             [(ngModel)]="ArcIpn"
             (ngModelChange)="ArcNameModelChange()">
      <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
        <button class="ng-clear cancel" (click)="resetArcaSearch('ArcIpn')"
                (keydown.enter)="resetArcaSearch('ArcIpn')" (keydown.space)="resetArcaSearch('ArcIpn')"
                tabindex="0">×</button>
      </span>
    </span>
    <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-section">
      <div class="breakline"><span class="breakline2">OR</span>
      </div>
    </span>
    <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-section">
      <label class="label-control" for="firstNameInput">First Name
      </label>
      <input type="text"
             id="firstNameInput"
             class="form-control form-control-sm"
             [(ngModel)]="ArcFirstName"
             (ngModelChange)="ArcNameModelChange()">
      <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
        <button class="ng-clear cancel" (click)="resetArcaSearch('ArcFirstName')"
                (keydown.enter)="resetArcaSearch('ArcFirstName')" (keydown.space)="resetArcaSearch('ArcFirstName')"
                tabindex="0">×</button>
      </span>
    </span>
    <span class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-section">
      <label class="label-control" for="lastNameInput">Last Name
      </label>
      <input type="text"
             id="lastNameInput"
             class="form-control form-control-sm"
             [(ngModel)]="ArcLastName"
             (ngModelChange)="ArcNameModelChange()">
      <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
        <button class="ng-clear cancel" (click)="resetArcaSearch('ArcLastName')"
                (keydown.enter)="resetArcaSearch('ArcLastName')" (keydown.space)="resetArcaSearch('ArcLastName')"
                tabindex="0">×</button>
      </span>
    </span>
    <div class="text-center" *ngIf="arcaSrchWait==true">
      <img src="assets/images/loading.gif" alt="loading...">
    </div>
    <div class="text-center" *ngIf="arcaSrchnoresults==true">
      <span> No search results</span>
    </div>
    <span class="table-responsive mt-3" *ngIf="resetArca==true">
      <table class="table table-sm m-0">
        <thead>
          <tr>
            <th class="ccwidth1" (click)="sort('code')" (keydown.enter)="sort('code')" (keydown.space)="sort('code')" tabindex="0">IPN</th>
            <th class="ccwidth1" (click)="sort('status')" (keydown.enter)="sort('status')"
                (keydown.space)="sort('status')" tabindex="0">First Name</th>
            <th class="ccwidth1" (click)="sort('label')" (keydown.enter)="sort('label')"
                (keydown.space)="sort('label')" tabindex="0">Last Name</th>
            <th class="ccwidth1" *ngIf="showUidDisable==false"> MANAGER</th>
          </tr>
        </thead>
        <tbody #customLoadingTemplate>
          <tr *ngFor="let cmdData of data | orderBy: key:reverse; let i=index">
            <td class="font-weight-bold">
              <span *ngIf="isaRoleFor_Uid[cmdData.Uid]=='manager' || showUidDisable==true">
                <button type="button" class="label-darkblue btn-link"
                        (click)="PasteSam(cmdData.Uid,cmdData.FirstName,cmdData.LastName,cmdData.Mail)">
                  {{cmdData ? cmdData.Uid : ''}} </button>
              </span>
              <span *ngIf="isaRoleFor_Uid[cmdData.Uid]!='manager' && showUidDisable==false">
                {{cmdData ? cmdData.Uid : ''}}
              </span>
            </td>
            <td class="font-weight-bold">{{cmdData ? cmdData.FirstName : ''}}
               </td>
            <td class="font-weight-bold">{{cmdData ? cmdData.LastName : ''}}</td>
            <td *ngIf="showUidDisable==false">
             <span *ngIf="isaRoleFor_Uid[cmdData.Uid]=='manager'">
                <img src="assets/images/greentick.png" alt="loading...">
              </span>
              <span *ngIf="isaRoleFor_Uid[cmdData.Uid]!='manager'"  >
                <img src="assets/images/close.png" alt="loading...">
                </span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
              <td colspan="4">
              </td>
          </tr>
        </tfoot>
      </table>
    </span>

    <div class="modal-footer border-0">
      <section class="bg-white no-shadow m-0">
        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="ArcSearch()">
          <mat-icon svgIcon="search" class="img-btn mr-2"></mat-icon> <span class="float-right"> Search </span>
        </button>
      </section>
    </div>
  </div>
</div>
</div>
<div class="modal fade" id="showWorkflowRejection" tabindex="-1" aria-modal="true"
     aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-ml-9">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel4">
          Reject The Request
          <button type="button" class="close" id="closeWorkflowRejection" #closeBtn
                  data-dismiss="modal" aria-label="Close" [hidden]="validatingWorkflow">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="!validatingWorkflow">
            <label class="label-control fontBold" for="rejectionNotes"> NOTES :<span class="element_astrick">*</span></label>
            <textarea id="rejectionNotes" class="form-control form-control-sm"
                      [(ngModel)]="wkfRejNotesModel" (keyup)="checkCommentsField()" maxlength="1000"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button class="ng-clear cancel" (click)="resetWkfRejNotesModel()"
                      (keydown.enter)="resetWkfRejNotesModel()" (keydown.space)="resetWkfRejNotesModel()"
                      tabindex="0">×</button>
            </span>
            <span class="error-color" *ngIf="rejectWorkflowNotesError==true">Please Enter Notes inorder to reject a workflow!!!</span>
          </div>
          <div  *ngIf="validatingWorkflow" class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="label-control fontBold"> Please wait ..</div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" [disabled]="validatingWorkflow==true"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-red reject-btn"
                  (click)="rejectWkfNoteRoute()" [disabled]="workflowValidationLoading==true">
            <mat-icon class="mr-2" svgIcon="less"></mat-icon><span class="float-right"> Reject </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="showWorkflowInfoRequest" tabindex="-1" aria-modal="true"
     aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-content-ml-9">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel5">
          More Information Request
          <button type="button" class="close" id="closeWorkflowInfoRequest" #closeBtn
                  data-dismiss="modal" aria-label="Close" [hidden]="validatingWorkflow">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"  *ngIf="!validatingWorkflow">
            <label class="label-control fontBold" for="infoRequestNotes"> NOTES :</label>
            <textarea id="infoRequestNotes" class="form-control form-control-sm"
                      [(ngModel)]="wkfInfoNotesModel" maxlength="1000"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button class="ng-clear cancel" (click)="resetWkfInfoNotesModel()"
                      (keydown.enter)="resetWkfInfoNotesModel()" (keydown.space)="resetWkfInfoNotesModel()"
                      tabindex="0">×</button>
            </span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div *ngIf="validatingWorkflow" class="label-control fontBold"> Please wait ..</div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal" [disabled]="validatingWorkflow"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue"
                  (click)="infoWkfNoteRoute()" [disabled]="workflowValidationLoading==true">
            <mat-icon svgIcon="info" class="rounded-circle info-icon"></mat-icon><span class="float-right pl-2"> Request </span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade mt-4" id="notesHistory" tabindex="-1" aria-modal = "true" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content modal-width-800">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel6">
          Workflow History
          <button type="button" class="close" id="closeNotesHistory" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div *ngIf="historyLoading">
        <div class="text-center">
                <img src="assets/images/loading.gif" alt="loading...">
              </div>
      </div>
      <div class="modal-body row m-0 p-0 table-responsive" *ngIf="requestForNotesHistory && !historyLoading">
        <div class="info-container mx-4 mb-2">
          <div class="info-row">
            <div class="label">Request Id:</div>
            <div class="value">
              <span class="text-60504a">{{ requestForNotesHistory?.requestId }}</span>&nbsp;
              <span >({{ requestForNotesHistory?.strRequestType }})</span>
            </div>
          </div>

          <div class="info-row">
            <div class="label">Company:</div>
            <div class="value">
              {{ requestForNotesHistory?.allianceId }} {{ requestForNotesHistory?.supplierName }}
            </div>
          </div>

          <div class="info-row" *ngIf="requestForNotesHistory?.requestor">
            <div class="label">Requestor:</div>
            <div class="value">
              <a href="mailto:{{ requestForNotesHistory?.RequestorMailId }}
                ?subject=ISA - {{ requestForNotesHistory?.requestId }} / {{ requestForNotesHistory?.supplierName }}"
                class="underline-link">
                {{ requestForNotesHistory?.requestor?.displayName }}
              </a>
            </div>
          </div>
          <div class="info-row" *ngIf="requestForNotesHistory?.approver">
            <div class="label">Approver:</div>
            <div class="value" [ngStyle]="approverColor(requestForNotesHistory?.workflowOwnerWithRole)">
              {{requestForNotesHistory?.approver}}
              <span class="edit ml-2"
                    *ngIf="requestForNotesHistory['status']=='In progress'
                      && requestForNotesHistory['workflowOwnerWithRole']!=''
                      && (roleVariableHide || superUserShow)">
                <mat-icon class="editIconStyle" svgIcon="edit" alt="edit" data-toggle="modal"
                          (click)="toggleApproverEdit()" (keydown.enter)="toggleApproverEdit()"
                          (keydown.space)="toggleApproverEdit()" tabindex="0"></mat-icon>
              </span>
            </div>
          </div>
        </div>
        <div class="info-row mx-4 mt-3">
          <div class="label">Status:</div>
          <div class="value">
            <span class="group-status px-3 mr-1 status-nowrap" [ngStyle]="{
                    background: colorForWorkflow[requestForNotesHistory?.status]
                  }">
              {{ requestForNotesHistory?.status }}
            </span>
          </div>
        </div>
        <br>
        <div *ngIf="!approverEdit">
        <table class="table m-0">
          <thead class="bg-f5f5f5">
            <tr class="col p-0">
              <th class="sortDecorationunderline" (click)="sort('requestor')"
                  (keydown.enter)="sort('requestor')" (keydown.space)="sort('requestor')" tabindex="0">User</th>
              <th class="sortDecorationunderline" (click)="sort('role')"
                  (keydown.enter)="sort('role')" (keydown.space)="sort('role')" tabindex="0">Role</th>
              <th class="sortDecorationunderline" (click)="sort('validation')"
                  (keydown.enter)="sort('validation')" (keydown.space)="sort('validation')" tabindex="0">Validation</th>
              <th class="sortDecorationunderline notes-width" (click)="sort('notes')"
                  (keydown.enter)="sort('notes')" (keydown.space)="sort('notes')" tabindex="0">Notes</th>
              <th class="sortDecorationunderline" (click)="sort('date')"
                  (keydown.enter)="sort('date')" (keydown.space)="sort('date')" tabindex="0">Date</th>
            </tr>
          </thead>
          <tbody *ngIf="requestForNotesHistory">
            <ng-container *ngFor="let detail of requestForNotesHistory['historys'] | orderBy: key:reverse; let i = index">
            <tr  class="col forColor p-0" >
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{detail.requestor}}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{detail.role ? detail.role : '-'}}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                <mat-icon *ngIf="detail.route == 'OK'" svgIcon="confirm" alt="greentick"
                          class="rounded-circle svg-icon green icon-pr-2"></mat-icon>
                <mat-icon *ngIf="detail.route == 'KO'" svgIcon="less" alt="redClose" class="rounded-circle red icon-pr-2"></mat-icon>
                <mat-icon *ngIf="detail.route == 'More info needed'" svgIcon="information" class="info-color icon-pr-2" ></mat-icon>
                <img src="assets/images/Submitted.png" alt="Submitted" class="rounded-circle" *ngIf="detail.route == 'Submitted'">
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold text-left">
                {{detail.comment ? detail.comment : '-'}}
              </td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">
                {{detail.date ? (detail.date | date:'yyyy-MM-dd') : '-'}}
              </td>
            </tr>
          </ng-container>
          </tbody>
          <tbody *ngIf="requestForNotesHistory.length==0">
            <tr>
              <td colspan="7" class="font-weight-bold label-darkblue text-center">No Results</td>
            </tr>
          </tbody>
           <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
        </table>
        </div>
        <div *ngIf="approverEdit">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" >
            <label class="label-control fontBold sendSupRec" for="newApproverInput"> New Approver <span class="astricRed">*</span></label>
            <input type="text"
                   id="newApproverInput"
                   class="form-control form-control-sm"
                   (focus)="focusFunction('sam')"
                   [(ngModel)]="senReqSamMOdel"
                   (keyup)="checkvalidateField()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button type="button" *ngIf="senReqSamMOdel!=''" class="ng-clear cancel"
                      (click)="resetSendReqToSupp('senReqSamMOdel')"
                      (keydown.enter)="resetSendReqToSupp('senReqSamMOdel')"
                      (keydown.space)="resetSendReqToSupp('senReqSamMOdel')" tabindex="0">
                <mat-icon svgIcon="search"></mat-icon>
              </button>
              <button type="button" *ngIf="senReqSamMOdel==''" data-toggle="modal" data-target="#ArcaPopup"
                      class="ng-clear cancel" (click)="lookupArca('sam')" (keydown.enter)="lookupArca('sam')"
                      (keydown.space)="lookupArca('sam')" tabindex="0">
                <mat-icon class="search-icon" svgIcon="search"></mat-icon>
              </button>
            </span>
            <span class="error-color" *ngIf="senReqSamMOdelError==true">Please enter the  MANAGER</span>
          </div>
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control fontBold sendSupRec" for="transferNotesTextarea"> Transfer NOTES </label>
            <textarea id="transferNotesTextarea" class="form-control form-control-sm" [(ngModel)]="senReqNotesMOdel"> </textarea>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button class="clear-icon" class="ng-clear cancel" type="button"
                      (click)="resetSendReqToSupp('senReqNotesMOdel')"
                      (keydown.enter)="resetSendReqToSupp('senReqNotesMOdel')"
                      (keydown.space)="resetSendReqToSupp('senReqNotesMOdel')" tabindex="0">×</button>
            </span>
          </div>
        </div>
      </div>
      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 row">
          <button *ngIf="!approverEdit" type="button" class="btn btn-custom btn-blue btn-lg grpBtn"
                  data-dismiss="modal" id="closeCatAuthState">
            Close
          </button>
          <button *ngIf="approverEdit" [disabled]="senReqSamMOdel==''" type="button"
                  class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal" id="closeCatAuthState1"
                  (click)="sendToNewApprover(requestForNotesHistory,senReqSamMOdel,senReqNotesMOdel)">
            Send to New Approver
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="d-none">
<button id="btnForArcaPopup" data-target="#ArcaPopup" data-toggle="modal"></button>
</div>
</div>
